// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3020":"1198f799","9276":"937cc543"}[chunkId] + ".chunk.css";
};